import pupa from 'pupa';
import { isEmptyObject, scopedErrorMessage } from '@philips-internal/oswald-ui-utils';
/**
 * Fetches a resource's data by path.
 * @param resource The resource info.
 * @param fallback The fallback value in case of the fetch failing.
 */
async function fetchResourceData(resource, fallback) {
    const response = await fetch(resource.location);
    if (response.ok) {
        return await response.json();
    }
    return fallback;
}
/**
 * Fetches the language data, overlapping base and locale-specific data.
 * @param languages An object of resource path values, indexed by language.
 * @param language The language to fetch.
 */
async function fetchLanguageDeltas(languages, language) {
    const resources = languageResources(languages, language);
    const promises = resources.map(async (resource) => {
        const data = await fetchResourceData(resource, {});
        return { data, language: resource.language };
    });
    return await Promise.all(promises);
}
function interpolate(expression, args = {}) {
    if (isEmptyObject(args)) {
        return expression;
    }
    try {
        const runtimeTemplate = expression.replaceAll('${', '{');
        return pupa(runtimeTemplate, args);
    }
    catch (error) {
        scopedErrorMessage('message-service', `Failed to translate expression '${expression}':`, error);
        return expression;
    }
}
/**
 * Language resource file paths to fetch.
 * Finds the paths to resources that belong to the specified language, **ordered from generic to specific**.
 * @param languages An object of resource path values, indexed by language.
 * @param language The language which the resource files should represent.
 */
function languageResources(languages, language) {
    const paths = [];
    if (language in languages) {
        paths.push({ language, location: languages[language] });
    }
    const [baseLanguage] = language.split('-');
    if (baseLanguage in languages) {
        paths.unshift({ language: baseLanguage, location: languages[baseLanguage] });
    }
    return paths;
}
/**
 * Normalizes language keys for safe and assertive comparisons.
 * Currently just uses **lower case**.
 * @param key The key to normalize.
 */
function normalizeLanguageKey(key) {
    return key.toLowerCase();
}
/**
 * Normalizes defaultLanguage and all language keys.
 * @param configuration The config to normalize.
 */
function normalizeConfiguration(configuration) {
    for (const key in configuration.languages) {
        if (!Object.prototype.hasOwnProperty.call(configuration.languages, key)) {
            continue;
        }
        configuration.languages[normalizeLanguageKey(key)] = configuration.languages[key];
    }
    return configuration;
}
export { fetchLanguageDeltas, interpolate, normalizeConfiguration, };
//# sourceMappingURL=message-service-utils.js.map